/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Content_Description_LabelInputs */



/**
* | output |
* | --- |
* | "Please describe the content in your own words" |
*
* @param {Content_Description_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const content_description_label = /** @type {((inputs?: Content_Description_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Content_Description_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez décrire le contenu avec vos propres mots.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte beschreiben Sie den Inhalt in Ihren eigenen Worten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrivi il contenuto con parole tue.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, опишите содержание своими словами.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor, describe el contenido con tus propias palabras.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请用您自己的话描述内容。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("内容をあなた自身の言葉で説明してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया विषयवस्तु का वर्णन अपने शब्दों में करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, descreva o conteúdo com suas próprias palavras.")
	return /** @type {LocalizedString} */ ("Please describe the content in your own words")
});